import { FIDELITY_URL, SCHWAB_URL } from 'src/constants/logo-urls/financial-institution-logo';
import { providerImgSrc } from 'src/utils/image';

type CustodianLogoSource = {
  readonly custodianName?: string | null;
  readonly providerLogoUrl?: string | null;
};

export function knownCustodianLogoUrl(custodianName: string | null | undefined): string | null {
  if (typeof custodianName !== 'string') return null;
  const normalized = custodianName.toLowerCase();
  if (normalized.includes('schwab')) return SCHWAB_URL;
  if (normalized.includes('fidelity')) return FIDELITY_URL;
  return null;
}

export function resolveCustodianLogoSrc({ custodianName, providerLogoUrl = null }: CustodianLogoSource): string | null {
  const knownLogo = knownCustodianLogoUrl(custodianName);
  if (knownLogo !== null) return knownLogo;
  if (providerLogoUrl === null || providerLogoUrl === '') return null;
  return providerImgSrc(providerLogoUrl) ?? null;
}
